/*
* Created on Mar 23, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useAlertContext} from "../../../context/AlertContext";
import {useOrganizationApi} from "../../../hook/OrganizationAPIHook";
import {useTranslation} from "react-i18next";
import {useRegion} from "../../../context/RegionContext";


const init_input = (size) => {
    const _input = {}
    for (let i=1; i<=size; i++) {
        _input[`cb${i}`] = {value: '', error: '', required: true, checked: false}
    }
    return _input
}

const OrganizationConfirmDeleteComponent = ({setStandalone, setShowFooter}) => {
    const {t} = useTranslation();
    const history = useNavigate();
    const alert = useAlertContext();
    const {deleteToken} = useParams();
    const {OrganizationAPI} = useOrganizationApi();
    const [input, setInput] = useState(init_input(7));
    const [disable, setDisable] = useState(true);
    const {url} = useRegion();

    const toggleCheckbox = (checkbox) => {
        setInput(prevInput => {
            prevInput[checkbox].checked = !prevInput[checkbox].checked;
            return {...prevInput}
        });
    }

    const validateInput = () => {
        for (const [key, value] of Object.entries(input) ) {
            if (!value.checked) {
                return false;
            }
        }
        return true;
    }

    const confirmDelete = async () => {
        try {
            await OrganizationAPI.delete(`confirm-delete-organization/${deleteToken}`);
            history('/delete-organization-success');
        } catch (e) {
            alert(true, 'error', e.response?.data?.code, e.response?.data?.message);
        }
    }

    useEffect(()=>{
        setDisable(!validateInput());
        setStandalone(true);
        setShowFooter(true);
        window.localStorage.removeItem('currentOrg');
        return ()=>{
            setStandalone(false);
            setShowFooter(false);
        }
    }, [input]);

    return (
        <div className="content-section">
            <div className="section-head">{t("@Delete Organization Consequence@")}</div>
            <div className="section-body">
                <div className="text-wrap fw5">{t("@Please note the following@")}:</div>
                <div className="text-wrap">
                    {t("@Once you delete your organization, any data associated with your deleted organization cannot be recovered.@")}
                </div>
                <div className="inner-frame">
                    <ul>
                        <li>
                            <div className="comp-checkbox-group">
                                <div className="comp-checkbox no-label">
                                    <input type="checkbox" id="cb1" value={input['cb1'].checked} onClick={()=>toggleCheckbox('cb1')}/>
                                    <label htmlFor="cb1" className="comp-label" />
                                </div>
                                <div className="val-field fs15 !pl-16 color-red"
                                     dangerouslySetInnerHTML={{
                                         __html: t('@Your purchased licenses on {license_manager} will be deleted permanently.@').replace(
                                             '{license_manager}',
                                             `<a href="${url.get_license_manager_url()}" target="_blank">${t('@QNAP License Manager@')}</a>`)
                                     }}
                                >
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="comp-checkbox-group">
                                <div className="comp-checkbox no-label">
                                    <input type="checkbox" id="cb2" value={input['cb2'].checked} onClick={()=>toggleCheckbox('cb2')} />
                                    <label htmlFor="cb2" className="comp-label" />
                                </div>
                                <div className="val-field fs15 !pl-16 color-red">
                                    {t('@All device under QuWAN service will be removed and the QuWAN private networking mesh between all devices will stop and all data transmission via QuWAN will stop.@')}
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="comp-checkbox-group">
                                <div className="comp-checkbox no-label">
                                    <input type="checkbox" id="cb3" value={input['cb3'].checked} onClick={()=>toggleCheckbox('cb3')}/>
                                    <label htmlFor="cb3" className="comp-label" />
                                </div>
                                <div className="val-field fs15 !pl-16">
                                    {t('@All your devices registered under this organization will be deleted.@')}
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="comp-checkbox-group">
                                <div className="comp-checkbox no-label">
                                    <input type="checkbox" id="cb4" value={input['cb4'].checked} onClick={()=>toggleCheckbox('cb4')}/>
                                    <label htmlFor="cb4" className="comp-label" />
                                </div>
                                <div className="val-field fs15 !pl-16">
                                    {t('@You will no longer have myQNAPcloud remote access services to all your devices.@')}
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="comp-checkbox-group">
                                <div className="comp-checkbox no-label">
                                    <input type="checkbox" id="cb5" value={input['cb5'].checked} onClick={()=>toggleCheckbox('cb5')}/>
                                    <label htmlFor="cb5" className="comp-label" />
                                </div>
                                <div className="val-field fs15 !pl-16">
                                    {t('@You can no longer use AMIZ Cloud services to manage your devices.@')}
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="comp-checkbox-group">
                                <div className="comp-checkbox no-label">
                                    <input type="checkbox" id="cb6" value={input['cb6'].checked} onClick={()=>toggleCheckbox('cb6')}/>
                                    <label htmlFor="cb6" className="comp-label" />
                                </div>
                                <div className="val-field fs15 !pl-16">
                                    {t('@You will not recieve notification on your paired mobile devices.@')}
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="comp-checkbox-group">
                                <div className="comp-checkbox no-label">
                                    <input type="checkbox" id="cb7" value={input['cb7'].checked} onClick={()=>toggleCheckbox('cb7')}/>
                                    <label htmlFor="cb7" className="comp-label" />
                                </div>
                                <div className="val-field fs15 !pl-16">
                                    {t('@All of the groups, sites, accounts list associated with this organization will be deleted.@')}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="section-footer clear">
                <div className="pull-right">
                    <div className="q-btn-group">
                        <button type="button" className="q-btn q-btn-primary q-btn-large" disabled={disable} onClick={async ()=> await confirmDelete()}>{t('@Confirm@')}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrganizationConfirmDeleteComponent;